export enum TagAssetEnum {
  BDFO,
  DTP,
  FU_INT,
  EX_INT,
  BAN,
  ORNA,
  LIGH,
  COAX,
  PXMCU,
  CAB,
  PXMFO,
  VS,
  TS,
  HS,
  BOX,
  FO,
  CU,
  TELCO,
  BU,
  LU,
  SU,
  CIRCLE_BLACK,
  CIRCLE_GREEN,
  CIRCLE_YELLOW,
  CIRCLE_RED,
  BDFO_TP,
  DTP_TP,
  FU_INT_TP,
  EX_INT_TP,
  BAN_TP,
  ORNA_TP,
  LIGH_TP,
  COAX_TP,
  PXMCU_TP,
  CAB_TP,
  PXMFO_TP,
  VS_TP,
  TS_TP,
  HS_TP,
  BOX_TP,
  FO_TP,
  CU_TP,
  TELCO_TP,
  BU_TP,
  LU_TP,
  SU_TP,
}
